import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {GlobalServices} from '../global.services';

@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.scss']
})
export class FaqsComponent implements OnInit {

  constructor(
    public globalServices: GlobalServices,
    private router: Router) { }

  ngOnInit(): void {
    if(this.globalServices?.isBrowser){
      this.globalServices?.hideHeader.next(false);
      this.globalServices?.hideFooter.next(false);
    }
  }
  public accordianChange(index:number):void{
    if(this.globalServices.isBrowser){
      if(index == 0){
        // this.moveToAppFaq
        this.router.navigate(['/app-onboarding-guide'])
      }
      else{
        let els:any = document.getElementsByClassName('accordian');
        if(els){
         let el:any = document.getElementsByClassName('accordian')[index];
         if(el.classList.contains('active')){
          el.classList.remove("active");
         }else{
        for(let elem of els){
          elem.classList.remove("active");
        }
         el.classList.add("active");
         }
        }
      }
   }
  }
}
